import {connect} from "react-redux"
import State from "../../../models/State"
import TrackFilterExpanded from "../../../events/trackEvent/events/trackFilterExpanded"
import {setSelectedFilterThunk} from "../../../ducks/tabbedFilters"
import {MOST_RELEVANT, SORT, SORT_BY} from "../../../config/constants"

export const mapStateToProps = (state: State) => {
    const {selectedFilter} = state.tabbedFilters
    const {selected, options} = state.search.sorting
    const hasSelectedFacet = Boolean(selectedFilter)
    const hasSelectedFilters = Boolean(selected)
    const selectedFacetFilters = options.find(option => option.value === selected)?.name || MOST_RELEVANT

    return {
        isFocused: hasSelectedFacet ? selectedFilter === SORT : undefined,
        hasSelectedFilters,
        hasSelectedFacet,
        selectedFacetFilters,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    setSelectedFacet: () => {
        TrackFilterExpanded(SORT_BY)
        dispatch(setSelectedFilterThunk(SORT))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
